import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleShipmentStatus } from "../../actions/ui_actions";

import { ActionButton } from "office-ui-fabric-react/lib/Button";

class ToggleShipmentStatusCallout extends Component {
  render() {
    return (
      <div
        id={
          this.props.item.id === this.props.shipment.id
            ? this.props.shipment.id
            : ""
        }
      >
        <ActionButton
          onClick={e => {
            e.preventDefault();
            this.props.toggle();
          }}
          title="Shipment status"
          iconProps={{
            iconName: "MoreVertical"
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps, {
  toggle: toggleShipmentStatus
})(ToggleShipmentStatusCallout);



// WEBPACK FOOTER //
// ./src/common/Buttons/_ToggleShipmentStatusCallout.js